import { Exclamation } from 'react-bootstrap-icons';

import { Button, message, Typography } from 'antd';

import { useGetBounceQuery, useDeleteBounceMutation } from '@/services/notifications';
import style, { css, StyledProp } from '@/styled';

const BounceWarning = (props: StyledProp) => {
  const bounce = useGetBounceQuery();
  const [deleteBounce] = useDeleteBounceMutation();

  const deleteBounceEmail = () => {
    deleteBounce()
      .unwrap()
      .then(() => {
        message.success('Bounce removido com sucesso');
      })
      .catch(() => {
        message.error('Erro ao remover bounce');
      });
  };

  const hasBounce = bounce?.data?.exists;

  if (!hasBounce) return null;

  return (
    <>
      <div className={props.className}>
        <div className='container'>
          <div className='title'>
            <Exclamation />
            <Typography.Title level={5}>Você não está recebendo nossos e-mails</Typography.Title>
          </div>

          <div className='item'>
            <Typography.Paragraph className='subtitle'>
              Para continuar sendo avisado das novidades e atualizações dos cursos, autorize para voltar a receber os
              novos e-mails do Nutror.
            </Typography.Paragraph>
            <Button type='primary' onClick={() => deleteBounceEmail()}>
              Autorizar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default style(BounceWarning)(
  ({ theme }) => css`
    .container {
      padding: ${theme.space.spacing(6, 6)};
      border: 1px solid ${theme.palette.brand.primary};
      border-radius: ${theme.borderRadius}px;
      margin-bottom: ${theme.space.spacing(4)};
    }

    .item,
    .title {
      display: flex;
    }

    .title svg {
      margin: ${theme.space.spacing(0, 4, 1, 0)};
      width: 20px;
      height: 20px;
      background: ${theme.palette.alpha(theme.palette.gray[2], 1)};
      border-radius: 50%;
      color: ${theme.palette.alpha(theme.palette.gray[12], 1)};
      flex-shrink: 0;
      align-self: center;
    }

    button {
      height: 36px;
      width: 177px;
      &:hover {
        background: ${theme.palette.alpha(theme.palette.gray[0], 0.04)};
        color: ${theme.palette.gray[4]};
      }
    }

    .subtitle {
      color: ${theme.palette.gray[3]};
      margin-left: ${theme.space.pxToRem(35)};
      margin-right: ${theme.space.pxToRem(10)};
    }

    ${theme.breakpoints.down('md')} {
      .item {
        flex-direction: column;
        align-items: flex-start;
        align-items: center;
      }

      button {
        width: 100%;
      }

      .subtitle {
        margin-left: ${theme.space.pxToRem(0)};
      }
    }
  `
);
